import { render, staticRenderFns } from "./UnderMaintenance.vue?vue&type=template&id=420fe6ee&scoped=true"
import script from "./UnderMaintenance.vue?vue&type=script&lang=js"
export * from "./UnderMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420fe6ee",
  null
  
)

export default component.exports